module.exports = __webpack_public_path__ + "static/img/monthgiftbg.301ae99.png";